import * as _4 from 'lodash4';
import { TransactionRequestType } from '../strategies/request_type_strategy';
import { TTransactionRequestType } from '../types/request_types';

export class RequestActionServant {
  constructor() {}

  getRequestType(type: TTransactionRequestType) {
    const actionType = _4.toUpper(type);

    return TransactionRequestType[actionType];
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/servants/request_action_servant.ts